<template>

</template>

<script>
  export default {
    computed: {
      canEditFull() {
        return this.lot.permissions.CAN_EDIT_FULL_LOT;
      },

      canEditPartially() {
        return this.lot.permissions.CAN_EDIT_LOT_PARTIALLY;
      },

      canEditNumberOfParts() {
        return this.canEditFull || this.canEditPartially
      }
    }
  }
</script>

<style scoped>

</style>
